import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { UserApiActions } from '../../../@store/user/user.actions';
import {
  selectArchivedUserError,
  selectArchivedUserSuccess,
} from '../../../@store/user/user.selectors';
import { SafeAny } from '../../../types/safe-any';

@Component({
  selector: 'ciwc-archive-user-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './archive-user-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchiveUserDialogComponent {
  private readonly store = inject(Store);
  readonly archivedUserSuccess = this.store.selectSignal(selectArchivedUserSuccess);
  readonly archivedUserError = this.store.selectSignal(selectArchivedUserError);

  isArchiving = signal(false);

  constructor(
    public dialogRef: MatDialogRef<ArchiveUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: SafeAny },
  ) {
    effect(() => {
      if (this.isArchiving()) {
        if (this.archivedUserSuccess()) {
          this.dialogRef.close();
        }

        if (this.archivedUserError()) {
          this.isArchiving.set(false);
        }
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isArchiving.set(true);

    this.store.dispatch(UserApiActions.archiveUser({ userId: this.data.user.id }));
  }
}
